import _ from "lodash";
import {numericFormatter} from "react-number-format";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import React from "react";

export const caseInsentitiveSearch = (word, searchValue) => {
    return word.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
}

export const searchPricings = (data, searchValue) => {
    if (searchValue.length > 0) {
        const filtered = {}
        _.map(data, (models, year) => {
            _.map(models, (model) => {
                let shouldPickModel = false
                if (caseInsentitiveSearch(model.name, searchValue)) {
                    shouldPickModel = true
                }
                let filteredTrims = []
                let shouldPickTrim = false
                _.map(model.trims, (trim) => {
                    if (caseInsentitiveSearch(trim.name, searchValue)) {
                        shouldPickTrim = true
                    }
                    _.map(trim.style_descriptions, (sd) => {
                        if (caseInsentitiveSearch(sd.name, searchValue)) {
                            shouldPickTrim = true
                        }
                    })

                    if (shouldPickTrim) {
                        filteredTrims.push(trim)
                    }
                })

                if (shouldPickModel) {
                    filtered[year] ||= []
                    filtered[year].push(model)
                }
                if (!shouldPickModel && shouldPickTrim) {
                    filtered[year] ||= []
                    let newModel = model
                    newModel.trims = filteredTrims
                    filtered[year].push(newModel)
                }
            })
        })

        return filtered
    } else {
        return data
    }
}

export const buildTrimAndStyleDescriptionName = (trimName, styleDescriptionName) => {
    const newName = trimName.split(" ")
    const split = styleDescriptionName.split(" ")
    split.forEach((word) => {
        if (!trimName.includes(word)) {
            newName.push(word)
        }
    })
    return newName.join(" ")
}

export const buildStyleDescriptionName = (trimName, styleDescriptionName) => {
    const newName = []
    const split = styleDescriptionName.replace("(Natl)", "").split(" ")
    split.forEach((word) => {
        if (!trimName.includes(word)) {
            newName.push(word)
        }
    })
    return newName.join(" ").trim()
}

export const parseGoogleAddressData = (address_components = []) => {
    let address_line_one = ''
    let zipcode = ''
    let state = ''
    let county = ''
    let city = ''
    for (const component of address_components) {
        for (const componentType of component.types) {
            switch (componentType) {
                case "street_number": {
                    address_line_one = `${component.long_name} ${address_line_one}`;
                    break;
                }

                case "route": {
                    address_line_one += component.short_name;
                    break;
                }

                case "postal_code": {
                    zipcode = `${component.long_name}`;
                    break;
                }
                
                case "sublocality_level_1": {
                    city = `${component.long_name}`;
                    break;
                }

                case "neighborhood": {
                    city = `${component.long_name}`;
                    break;
                }

                case "locality":
                    city = component.long_name;
                    break;

                case "administrative_area_level_1": {
                    state = component.short_name;
                    break;
                }
                case "administrative_area_level_2": {
                    county = component.short_name;
                    break;
                }
            }
        }
    }

    return {
        address_line_one,
        zipcode,
        state,
        county,
        city
    }
}

export const parsedAddressObjectToString = (addressObject) => {
    if (!addressObject) return '';

    const {
        address_line_one,
        city,
        state,
        zipcode
    } = addressObject
    return `${address_line_one} ${city} ${state} ${zipcode}`

}

export const toTitleCase = (str) => {
    return str.replace(
        /\w\S*/g,
        text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
}

export const buildCarString = (car_detail) => {
    if (car_detail) {
        return `${car_detail.year} ${car_detail.make} ${car_detail.model} ${car_detail.trim}`
    } else {
        return ''
    }
}

export const formatDate = (date) => {
    if (!date) return null;
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}

export const buildLocationString = (location) => {
    if (!location) return ''
    // Join only the parts we actually have. County is preferred but is often
    // missing (Google omits administrative_area_level_2 for some ZIPs, e.g.
    // 91362), so fall back to city; dropping empty segments prevents a stray
    // leading comma like ", CA, 91362".
    return [location.county || location.city, location.state, location.zipcode]
        .filter(Boolean)
        .join(', ')
}

export const rebateIdHelper = (rebate) => {
    let uniqueId = rebate.external_id
    if (uniqueId === null) {
        uniqueId = rebate.name
    }
    return String(uniqueId)
}

export const getPaginationButtons = (startIndex, pageSize, totalCount) => {
    const currentPage = Math.floor(startIndex / pageSize) + 1;
    const totalPages = Math.ceil(totalCount / pageSize);

    const buttons = new Set();

    // Always include first and last page
    buttons.add(1);
    buttons.add(totalPages);

    // Add current page and its neighbors
    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        if (i >= 1 && i <= totalPages) buttons.add(i);
    }

    // Sort and insert ellipsis where there are gaps
    const sorted = [...buttons].sort((a, b) => a - b);

    const result = [];
    for (let i = 0; i < sorted.length; i++) {
        if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
            result.push('...');
        }
        result.push(sorted[i]);
    }

    return result;
}